var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "10 10 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-2{stroke:#fff;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5809",
    "data-name": "Path 5809",
    className: "cls-1",
    d: "M24.7,44.14a1.23,1.23,0,0,0,1.23-1.23V36.76h1.23a3.69,3.69,0,0,0,3.69-3.69V31.19a10.15,10.15,0,0,0-5.6-9.06,1.24,1.24,0,0,0-1.65.55,1.17,1.17,0,0,0-.13.55V42.9a1.23,1.23,0,0,0,1.22,1.24Zm1.23-18.58a7.66,7.66,0,0,1,2.46,5.63v1.88a1.24,1.24,0,0,1-1.24,1.23H25.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5810",
    "data-name": "Path 5810",
    className: "cls-1",
    d: "M35.76,34.11v8.8a1.23,1.23,0,1,0,2.46.11V34.11a6.05,6.05,0,0,0,3.69-5.95,5,5,0,1,0-9.83,0A6,6,0,0,0,35.76,34.11ZM37,24.47c1.34,0,2.46,1.69,2.46,3.69S38.32,31.84,37,31.84s-2.46-1.69-2.46-3.68,1.13-3.7,2.46-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5811",
    "data-name": "Path 5811",
    className: "cls-2",
    d: "M24.69,56.52H54.2a1.23,1.23,0,0,0,1.23-1.23h0V47.83A1.23,1.23,0,0,0,54.2,46.6H48.06V15.78a1.24,1.24,0,0,0-1.23-1.24H17.32a1.23,1.23,0,0,0-1.23,1.23h0V47.83A8.66,8.66,0,0,0,24.69,56.52ZM53,49.06v4.87a6.21,6.21,0,0,1-4.8-4.87ZM18.55,17h27V47.83a8.69,8.69,0,0,0,2.62,6.23H24.69a6.19,6.19,0,0,1-6.14-6.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5812",
    "data-name": "Path 5812",
    className: "cls-1",
    d: "M24.7,49.06H39.45a1.23,1.23,0,1,0,.11-2.46H24.7a1.23,1.23,0,1,0-.11,2.46Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.73d49e5cd071177a3abbd0d5e59b948f.svg";
export { ForwardRef as ReactComponent };